import React from "react";

function IllustrationRdcBuyerDemand() {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 129 96">
      <path
        d="M90.758 39.628h1.962v9.39h16.958V23.37L94.122 13l-.841.56-14.716 9.81v25.647h12.193v-9.39Zm-2.803 6.587h-6.587V24.912l12.754-8.408 12.753 8.408v21.303H95.523v-9.39h-7.568v9.39ZM68.755 73.263c-.56-2.523-1.401-7.849-2.102-12.333a67.75 67.75 0 0 1-.84-6.026c0-.28-.14-.701-.14-.982h45.967c.841 0 1.402-.56 1.402-1.4 0-.842-.561-1.402-1.402-1.402H16.901c-.84 0-1.401.56-1.401 1.401s.56 1.401 1.401 1.401H62.31c0 .28-.14.561-.14.982-.28 2.382-.841 6.026-1.402 9.53-.56 3.503-1.121 7.007-1.542 8.829-.56 2.522-1.26 4.344-1.681 5.325-.28.56-.42.981-.56 1.121l-.14.28c-.281.421-.281.982-.141 1.402.28.42.7.7 1.261.7h12.613c.561 0 1.121-.28 1.262-.84.28-.56.14-1.121-.28-1.542v-.14c-.421 0-1.822-1.962-2.803-6.306Z"
        className="fill-secondary"
      />
      <path
        d="M19.333 37.717c0 2.02 1.667 3.705 3.667 3.705-7.5 0-7.5 4.378-7.5 7.578h15c0-3.2 0-7.578-7.5-7.578 2 0 3.667-1.684 3.667-3.705S25 34 23 34c-2 0-3.667 1.527-3.667 3.717ZM34.333 37.717c0 2.02 1.667 3.705 3.667 3.705-7.5 0-7.5 4.378-7.5 7.578h15c0-3.2 0-7.578-7.5-7.578 2 0 3.667-1.684 3.667-3.705S40 34 38 34c-2 0-3.667 1.527-3.667 3.717ZM26.333 22.717c0 2.02 1.667 3.705 3.667 3.705-7.5 0-7.5 4.378-7.5 7.578h15c0-3.2 0-7.578-7.5-7.578 2 0 3.667-1.684 3.667-3.705S32 19 30 19c-2 0-3.667 1.527-3.667 3.717Z"
        className="fill-primary"
      />
    </svg>
  );
}

export default IllustrationRdcBuyerDemand;
